import { render, staticRenderFns } from "./galleryImage_list.vue?vue&type=template&id=096d205c&scoped=true&"
import script from "./galleryImage_list.vue?vue&type=script&lang=js&"
export * from "./galleryImage_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d205c",
  null
  
)

export default component.exports